import { Label } from "../model/Label.js";
import { Modal, ModalOptions } from "./Modal.js";
import { ModalItem } from "./ModalItem.js";

export interface SettingsWindowOptions extends ModalOptions {

}

export class SettingsWindow extends Modal {
    public create(options: SettingsWindowOptions): this {

        super.create(options);

        this.element.id = "settings-window";

        e5.event.on(document.body, "click", `[data-action="openmenu"][aria-controls="${this.element.id}"]`, (e) => {
            this.show({
                fromHistory: false,
                initiator: e.target
            });
        });

        if (e5.Plugins.notification.supported) {
            this.addInfo(Label.label("main.subscription.title"));

            var btn = this.addItem({
                icon: "fal fa-spinner fa-spin",
                label: Label.label("main.subscription.button.label"),
                subtitle: Label.label("main.subscription.button.subtitle"),
                iconSize: "large",
                closeOnClick: false
            });

            this.setSubscribeButton(btn);
        }

        return this;
    }

    private async setSubscribeButton(btn: ModalItem) {
        var idle = false;
        var isSubscribed = await e5.Plugins.notification.isSubscribed();

        var updateIcon = () => {
            if (e5.Plugins.notification.permission === "denied") {
                btn.icon = "fal fa-bell-slash";
            }
            else if (idle) {
                btn.icon = "fal fa-spinner fa-spin";
            } else {
                btn.icon = isSubscribed ? "fal fa-toggle-on" : "fal fa-toggle-off";
            }
            btn.iconInactive = idle ? false : !isSubscribed;
        }
        updateIcon();
        e5.Plugins.notification.onChangePermission.add(updateIcon);

        e5.Plugins.notification.onChange.add((isSub) => {
            isSubscribed = isSub;
            //HMMMMMMMMMM ????
            idle = false;
            updateIcon();
        })

        btn.element.addEventListener("click", async () => {
            if (idle
                || e5.Plugins.notification.permission === "denied") {
                return;
            }

            idle = true;
            updateIcon();

            if (isSubscribed) {
                var unsub = await e5.Plugins.notification.unsubscribe();
                isSubscribed = !(unsub === "unsubscribed");
            } else {
                var sub = await e5.Plugins.notification.subscribe();
                isSubscribed = sub === "subscribed";
            }

            idle = false;
            updateIcon();
        });
    }
}